import React, { useState, useEffect } from 'react';
import { Button, List, ListItem, Text, Icon, Title, Header, Body, Right, View, Left } from 'native-base';
import { View as RnView } from 'react-native';
import { Chip } from 'react-native-paper';
import Modal from '../../components/modal';
import { Field } from 'redux-form';
import * as _ from 'lodash';
import Alert from '../../components/alert';

export default function FormSelector({ fields, list, meta: { touched, error, ...oMeta }, ...otherStuff }) {
	const [showList, setShowList] = useState(false);

	const chips = fields.getAll();

	//console.log('formSelectar', list, chips); //can we access other fields? NO
	return (
		<>
			{showList && (
				<Modal
					isOpen={showList}
					//swipeArea={100}
					animationDuration={100}
					coverScreen
					onClosed={() => setShowList(false)}
					backButtonClose
					style={{
						maxHeight: '95%',
						height: 'auto',
						width: '95%',
						justifyContent: 'center'
					}}
					//backdropOpacity={0.7}
					useNativeDriver>
					<Header>
						<Body>
							<Title>Add a form</Title>
						</Body>
					</Header>
					<List style={{ backgroundColor: 'white' }}>
						{list.map((item, i) => {
							var sames = _.filter(chips, { sa: item.sa, show: true }).length;
							var ordinal = sames ? sames + 1 : '';
							var tooMany = sames >= item.maxNum;
							if (tooMany) return null;

							return (
								<ListItem
									key={i}
									disabled={tooMany}
									onPress={() => {
										fields.push({ ...item, name: item.name + ordinal, show: true });
										setShowList(false);
									}}>
									<Left>
										<Text>{item.sa}</Text>
									</Left>
									<Body style={{ flex: 2 }}>
										<Text style={{ color: tooMany ? 'grey' : 'black' }}>{item.display}</Text>
									</Body>
									<Right style={{ flexGrow: 1 }}>
										<Text style={{ color: tooMany ? 'grey' : 'black' }}>{item.name}</Text>
									</Right>
								</ListItem>
							);
						})}
					</List>
				</Modal>
			)}
			<RnView style={{ margin: 10, flexWrap: 'wrap', flex: 1, flexDirection: 'row', justifyContent: 'center' }}>
				{chips &&
					chips.map((member, index) => {
						return (
							member.show && (
								<Chip
									key={index}
									onClose={member.sa == 'SA100' || member.auto ? false : () => fields.remove(index)}
									mode="outlined"
									//textStyle={{ flexBasis: 70, flexGrow: 250 }}
									onPress={() =>
										Alert.alert(member.sa + (member.ordinal ? member.ordinal : ''), (member.auto ? `(Added from your selection above)\n` : '') + member.display + `\n` + (member.desc || ''))
									}>
									{member.sa + `\n`}
									<Text note> {member.display} </Text> {member.ordinal ? member.ordinal : ''}
								</Chip>
							)
						);
					})}
			</RnView>
			<Button iconLeft style={{ margin: 10 }} onPress={() => setShowList(true)}>
				<Icon name="ios-add-circle-outline" />
				<Text>Add More</Text>
			</Button>
		</>
	);
}
